"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useVideoJSMetrics = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("react");
var _StudioLogger = require("@studio/logger/StudioLogger");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var logger = new _StudioLogger.StudioLogger('VideoJSMetric');

/**
 * Hook to measure video playback metrics using Video.js player.
 * @param source
 * @param playerRef
 */
var useVideoJSMetrics = exports.useVideoJSMetrics = function useVideoJSMetrics(source, playerRef) {
  var _source$value;
  var player = playerRef.current;
  var playingTime = (0, _react.useRef)(null);
  var playerStartTime = (0, _react.useRef)(null);
  var title = source.title,
    ext = source.ext,
    _id = source._id;
  var payload = {
    videoTitle: title,
    ext: ext,
    videoId: (_source$value = source.value) === null || _source$value === void 0 ? void 0 : _source$value.eventDocId
  };
  (0, _react.useEffect)(function () {
    if (!player) return;
    var lastPlayedQuality = null;
    playerStartTime.current = performance.now();
    function getVideoDuration() {
      return Math.round(player.duration()) * 1000;
    }
    player.on('playing', function () {
      if (playerStartTime.current !== -1) {
        playingTime.current = performance.now();
        var totalLoadTime = (playingTime.current - playerStartTime.current).toFixed(3);
        logger.info("VideoJS - Time taken from loading to playback: ".concat(totalLoadTime, " ms"), _objectSpread(_objectSpread({}, payload), {}, {
          videoPlaybackDuration: totalLoadTime,
          videoDurationMs: getVideoDuration()
        }));
        playerStartTime.current = -1;
      }
    });
    player.on('timeupdate', function () {
      var width = player.videoWidth();
      var height = player.videoHeight();
      if (!width || !height) return;
      var quality = "".concat(width, "x").concat(height);
      if (quality !== lastPlayedQuality) {
        lastPlayedQuality = quality;
        logger.info("VideoJS - Playback Quality: ".concat(quality), {
          sourceId: _id,
          width: width,
          height: height,
          name: title,
          videoDurationMs: getVideoDuration()
        });
      }
    });
    return function () {
      if (player) {
        player.off('playing');
        player.off('timeupdate');
      }
    };
  }, [player]);
};